let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gO807")).then(() => parcelRequire('qhZuk'));